export const PRODUCT_CONDITIONS = ['New', 'Used', 'Refurbished'] as const
